import type { ExtractPreviewResponse, StandardExtractSection } from '@/shared/hooks/api/userStandards'

export function getSectionSourceLocaleFromPreview(
  section: StandardExtractSection,
  preview: ExtractPreviewResponse
): string | undefined {
  if (section === 'significantHazards') {
    return preview.significantHazards?.sourceLocale
  }
  if (section === 'riskReductionMeasures') {
    return preview.riskReductionMeasures?.sourceLocale
  }
  if (section === 'informationForUse') {
    return preview.informationForUse?.sourceLocale
  }
  return undefined
}
